/* lua.js generated code 0.3.0 */

let Events = require("cocos/framework/components/event")
var TTDouyinFAQButton = xClass("TTDouyinFAQButton", cc.Node, Events)


TTDouyinFAQButton.prototype.ctor = function () {
    let self = this
    self.bind(self)
    cc.Node.prototype.ctor.call(self)
    self.nodeExist = true
    self.init()
}
TTDouyinFAQButton.prototype.init = function () {
    let self = this
    
    let mainSp = cc.Sprite.createWithSpriteFrameName("homeScene/faq_img.png");
    self.addChild(mainSp)
    var btn = UIButton.create(mainSp)
    btn.on(UIButtonEvent.Click, handler(self, self.openCustomerServiceConversation))
    self.btn = btn
}

TTDouyinFAQButton.prototype.openCustomerServiceConversation = function () {
    if (mini.supportCustomerServiceType3 && mini.supportCustomerServiceType3()) {
        mini.openCustomerServiceConversation({
            type:3
        })
    }else{
        mini.openCustomerServiceConversation({
            type:2
        })
    }
}

module.exports = TTDouyinFAQButton
